module.exports = __webpack_public_path__ + "img/sprinkle-11.fd903706.webp";